import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useOnboarding } from "@/hooks/use-onboarding";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import logoSrc from "@/assets/logo.svg";
import { OnboardingIllustration } from "./OnboardingIllustrations";

/**
 * Ecran de bienvenue unique au premier login. Le guidage pas-à-pas (créer une
 * landing, recevoir un lead) est porté par la checklist d'activation du
 * dashboard (voir GettingStarted).
 */
export default function OnboardingTour() {
  const { showOnboarding, completeOnboarding } = useOnboarding();
  const [dismissed, setDismissed] = useState(false);

  const visible = showOnboarding && !dismissed;

  const finish = () => {
    completeOnboarding();
    setDismissed(true);
  };

  return (
    <Dialog open={visible} onOpenChange={(v) => { if (!v) finish(); }}>
      <DialogContent className="max-w-md p-0 overflow-hidden gap-0">
        <DialogTitle className="sr-only">Bienvenue sur Magnetiq</DialogTitle>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-center gap-5 px-6 pt-8 pb-4 text-center"
        >
          <img src={logoSrc} alt="Magnetiq" className="h-7" />
          <div className="w-full max-w-[280px] rounded-lg overflow-hidden shadow-md">
            <OnboardingIllustration step={0} />
          </div>
          <div className="space-y-2">
            <h2 className="font-['Bricolage_Grotesque'] text-xl font-extrabold tracking-tight">
              Bienvenue sur Magnetiq
            </h2>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm">
              Créez des landing pages qui transforment vos visiteurs en leads, et suivez tout depuis un seul endroit. On vous guide, étape par étape.
            </p>
          </div>
        </motion.div>

        <div className="flex items-center justify-end border-t px-6 py-4">
          <Button
            size="sm"
            onClick={finish}
            className="gap-2 bg-highlight text-highlight-foreground hover:bg-highlight/90"
          >
            C'est parti
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
